import { $vfm } from 'vue-final-modal'

// export const useModalOpener = (
//   params: Record<string, unknown>,
//   component = 'UiModalContainer',
// ): void => {
//   $vfm.show({
//     component,
//   }, {
//     ...params,
//   })
// }

export const useModalOpener = (
  params: Record<string, unknown> & {
    onClose?: () => void
  },
  component = 'UiModalContainer',
): void => {
  const modal = $vfm.show(
    {
      component,
      bind: {
        onClosed: () => {
          params.onClose?.()   // Вызов при закрытии
        },
      },
    },
    {
      ...params,
    }
  )
}

export const useShowModal = (
  message: {
    title: string,
    text?: string,
  },
  params?: Record<string, unknown>,
  classes = [],
  component = 'Modals/UiMessageModal',
): void => {
  useModalOpener({
    message,
    ...params,
    classes,
    component,
  })
}

export function useConfirmWithArg(
  message: {
    title: string,
    text?: string,
  },
  component = 'Modals/UiConfirmModal',
  classes = ['modal--space_1'],
): Promise<boolean> {
  return new Promise(resolve => {
    const promise = (arg: boolean) => {
      resolve(arg) // вернёт true или false
    }

    useModalOpener({
      message,
      classes,
      promise,
      component,
      onClose: () => resolve(false), // <— добавляем обработку закрытия
    })
  })
}


export function useConfirmWithPromise(
  message: {
    title: string,
    text?: string,
  },
  component = 'Modals/UiConfirmModal',
  classes = ['modal--space_1'],
): any {
  return new Promise(resolve => {
    const promise = (arg: boolean) => new Promise(res => {
      if (arg) {
        res(arg)
      }
    }).then(result => {
      resolve(result)
    })
    useModalOpener({
      message,
      classes,
      promise,
      component,
    })
  })
}
